import { IOfferScopeStatusLang } from '../../../types/lang'
import { EOfferScopeStatus } from '../../../types'

export const offerScopeStatusLang: IOfferScopeStatusLang = {
	offer_scope_status: {
		[EOfferScopeStatus.none]: 'none',
		[EOfferScopeStatus.active]: 'active',
		[EOfferScopeStatus.paused]: 'paused',
		[EOfferScopeStatus.closed]: 'closed',
	}
}